var _path, _rect, _path2, _rect2, _path3, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUndorderedList = function SvgUndorderedList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 2.66667C2.7364 2.66667 3.33335 2.06971 3.33335 1.33333C3.33335 0.596954 2.7364 0 2.00002 0C1.26364 0 0.666687 0.596954 0.666687 1.33333C0.666687 2.06971 1.26364 2.66667 2.00002 2.66667Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.33337,
    y: 0.333496,
    width: 14,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 8.33317C2.7364 8.33317 3.33335 7.73622 3.33335 6.99984C3.33335 6.26346 2.7364 5.6665 2.00002 5.6665C1.26364 5.6665 0.666687 6.26346 0.666687 6.99984C0.666687 7.73622 1.26364 8.33317 2.00002 8.33317Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33337,
    y: 6,
    width: 14,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 14.0002C2.7364 14.0002 3.33335 13.4032 3.33335 12.6668C3.33335 11.9304 2.7364 11.3335 2.00002 11.3335C1.26364 11.3335 0.666687 11.9304 0.666687 12.6668C0.666687 13.4032 1.26364 14.0002 2.00002 14.0002Z",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33337,
    y: 11.667,
    width: 14,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUndorderedList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "undordered-list.f35540a23153728d66365186bdc4c4b8.svg";